module.exports = __webpack_public_path__ + "8c6e85d04976c561b62d17a6cd2562f8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/bg_img_1920x1400.png
// module id = 189
// module chunks = 0